import NavBar from "./layouts/nav/NavBar";
import Footer from "./layouts/footer/Footer";
import HomePage from "./pages/home/homePage";
import LoginPage from "./pages/authentication/LoginPage";
import { Routes, Route, useLocation } from "react-router-dom";
import SignupPage from "./pages/authentication/SignupPage";
import ProgramsPage from "./pages/Programs/Programs";
import ForgetPasswordPage from "./pages/authentication/ForgetPasswordPage";
// import Blogs from "./pages/blogs/BlogsPage";
// import BlogPage from "./pages/blogs/blogpage/BlogPage";
import ProgramDetails from "./pages/programDetails/ProgramDetails";
import Profile from "./pages/profile/Profile";
import Reviews from "./pages/reviews/UserReviews";
import AboutUs from "./pages/aboutUs/AboutUs";
import PersonalInfo from "./pages/profile/Personal Information/PersonalInfo";
import HideComponent from "./layouts/hideComponent/HideComponent";
import NotFound from "./layouts/notFound/NotFound";
import GenericForm from "./generic components/generic form/GenericForm";
import AdminPage from "./pages/admin/AdminPage";
import Policy from "./pages/policy/Policy";
import DummyForm from "./pages/dummy form/DummyForm";
import MyToaster from "./generic components/toaster/MyToaster";
import Terms from "./pages/termsConditions/Terms";
import Faqs from "./pages/faqs/Faqs";
import Facebook from "./utils/FacebookPixel";
import { ConfigProvider } from "antd";
import CareersPage from "./pages/Careers/Careers";
import HostingOrganizationPortal from "./pages/HostingPortal/HostingPortal";
import SendingOrganizationPortal from "./pages/SendingPortal/SendingPortal";
import EventsPage from "./pages/Events/Events";
import BlogsPage from "./pages/blogs/BlogsPage";
import BlogPage from "./pages/blogs/blogpage/BlogPage";
import { useEffect } from "react";
import TeamPortal from "./pages/Team/Team";
import CapacityProjects from "./pages/Capacity/CapacityProjects";
import ProjectNewsSinglePage from "./pages/Capacity/ProjectNewsSinglePage/ProjectNewsSinglePage";
import CapacityProjectPage from "./pages/Capacity/ProjectPage/CapacityProjectPage";
import SingleEvent from "./pages/Events/SingleEvent/SingleEvent";

function App() {
  const location = useLocation();
  const isAdminRoute = location.pathname.includes("/admin");
  const isSendingPage = location.pathname.includes("/sending");
  useEffect(() => {
    if (!isSendingPage) {
      window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
    }
  }, [JSON.stringify(location)]);

  return (
    <ConfigProvider
      theme={{
        token: {
          colorPrimary: "#fe643f",
        },
      }}
    >
      <MyToaster />
      <HideComponent>
        <NavBar />
      </HideComponent>
      <Facebook />
      <Routes scrollRestoration="top">
        <Route path="/form" element={<DummyForm />} />
        <Route path="/adminForm" element={<GenericForm />} />
        <Route path="/" element={<HomePage />} />
        <Route path="/login" element={<LoginPage />} />
        <Route path="/signup" element={<SignupPage />} />
        <Route path="/PersonalInfo" element={<PersonalInfo />} />
        <Route path="/forgetPassword/:id" element={<ForgetPasswordPage />} />
        <Route path="/programs" element={<ProgramsPage />} />
        <Route path="/careers" element={<CareersPage />} />
        <Route path="/hosting" element={<HostingOrganizationPortal />} />
        <Route path="/sending" element={<SendingOrganizationPortal />} />
        <Route path="/events" element={<EventsPage />} />
        <Route path="/events/:id" element={<SingleEvent />} />
        <Route path="/blogs" element={<BlogsPage />} />
        <Route path="/team" element={<TeamPortal />} />
        <Route path="/blogs/:id" element={<BlogPage />} />
        <Route path="/programs/:id" element={<ProgramDetails />} />
        <Route path="/profile/:id" element={<Profile />} />
        <Route path="/about" element={<AboutUs />} />
        <Route path="/reviews" element={<Reviews />} />
        <Route path="/admin/*" element={<AdminPage />} />
        <Route path="/policy" element={<Policy />} />
        <Route path="/terms&conditions" element={<Terms />} />
        <Route path="/faq" element={<Faqs />} />

        <Route path="/capacity-projects" element={<CapacityProjects />} />
        <Route
          path="/capacity-projects/:idOrSlug"
          element={<CapacityProjectPage />}
        />
        <Route
          path="/capacity-projects/:projectIdOrSlug/news/:newsIdOrSlug"
          element={<ProjectNewsSinglePage />}
        />
        <Route
          path="/capacity-news/:newsIdOrSlug"
          element={<ProjectNewsSinglePage />}
        />

        <Route path="*" element={<NotFound />} />
      </Routes>
      <HideComponent>{!isAdminRoute && <Footer />}</HideComponent>
    </ConfigProvider>
  );
}

export default App;
